<!-- <link href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css" rel="stylesheet"> -->

<div class="container-fluid mt-4">
  <div class="mb-3">
    <button class="btn btn-primary" (click)="deleteSelectedUsers()">Delete Selected Users</button>
  </div>

  <div class="row mb-3">
    <div class="col-md-6">
      <input
        type="text"
        class="form-control search-input"
        placeholder="Search by username, email, first name, or last name..."
        [(ngModel)]="searchQuery"
      />
      <button class="form-control search-button" (click)="searchUser()">Search</button>
    </div>

    <div class="col-md-4 offset-md-2">
      <select
        class="form-select"
        [(ngModel)]="sortField"
        (change)="changeFilter()">
        <option value="email">Email</option>
        <option value="username">Username</option>
        <option value="given_name">First Name</option>
        <option value="family_name">Last Name</option>
        <option value="confirmed">Confirmed Status</option>
        <option value="force_change_password">Change Password Status</option>
      </select>
    </div>
  </div>

  <div class="table-container">
    <table class="table fixed-header-table">
      <thead class="table-light">
        <tr>
          <th style="width: 2%;"></th>

          <th (click)="setSortField('username')">
            User Id <i [class]="'bi bi-sort-' + (sortField === 'username' ? sortOrder : 'up')"></i>
          </th>
          <th (click)="setSortField('email')">
            Email <i [class]="'bi bi-sort-' + (sortField === 'email' ? sortOrder : 'up')"></i>
          </th>
          <th (click)="setSortField('given_name')">
            First Name <i [class]="'bi bi-sort-' + (sortField === 'given_name' ? sortOrder : 'up')"></i>
          </th>
          <th (click)="setSortField('family_name')">
            Last Name <i [class]="'bi bi-sort-' + (sortField === 'family_name' ? sortOrder : 'up')"></i>
          </th>
          <th (click)="setSortField('user_status')">
            Status <i [class]="'bi bi-sort-' + (sortField === 'user_status' ? sortOrder : 'up')"></i>
          </th>
          <th  (click)="setSortField('location')">
            Location <i [class]="'bi bi-sort-' + (sortField === 'location' ? sortOrder : 'up')"></i>
          </th>
        </tr>
      </thead>
      <tbody style="max-height: 70vh; overflow-y: auto; border: 1px solid #dee2e6;">
        @for(user of this.cognito.cognitoUsersArray; let i = $index; track user){
          <tr>
            <!-- Checkbox for each user -->
            <td class="td"  [ngClass]="{ 'alternate-row': i % 2 === 1 }" style="width: 2%;">
              <input
                type="checkbox"
                [checked]="selectedUsers.includes(user)"
                (change)="toggleUserSelection(user)"
              />
            </td>
            <td class="td" [ngClass]="{ 'alternate-row': i % 2 === 1 }">
              @if(this.manageService.userHasRoles('_developper', true)){
                <a (click)="this.manageService.openUserRoleModal(user.username)">{{ user.username }}</a>
              }
              @else{
                <p>{{ user.username }}</p>
              }
            </td>
            <td class="td" [ngClass]="{ 'alternate-row': i % 2 === 1 }">
              {{ user.email }}
              @if(user.email_verified === 'false'){
                <img src="../../assets/not_verified.png">
              }
              @else{
                <img src="../../assets/verified.png">
              }
            </td>
            <td class="td" [ngClass]="{ 'alternate-row': i % 2 === 1 }">{{ user.given_name }}</td>
            <td class="td" [ngClass]="{ 'alternate-row': i % 2 === 1 }">{{ user.family_name }}</td>
            <td class="td" [ngClass]="{ 'alternate-row': i % 2 === 1 }">{{ user.user_status }}</td>
            <td class="td-location td" [ngClass]="{ 'alternate-row': i % 2 === 1 }">
              <a class="a-location" (click)="triggerLocationDropbox(user.email, user.syuser?.location);">{{ user.syuser?.location }}</a>
                @if(!this.displayLocationMessage && this.activeUserEmail === user.email){
                  <select class="form-select location-select" [(ngModel)]="selectedLocation" (change)="changeUserLocation(user);">
                    <option value="NA">NA</option>
                    <option value="EUR">EUR</option>
                    <option value="CH">CH</option>
                    <option value="ME">ME</option>
                    <option value="DEV">DEV</option>
                    <option value="QAS">QAS</option>
                  </select>
                }
                @if(this.displayLocationMessage){
                  <div>
                    {{ this.apiService.locationUpdateMessage | translate }}
                  </div>
                }
              <!-- </div> -->
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if(this.cognito.cognitoUsersArray.length === 0){
    <div class="mt-3">
      <p class="text-center">No users found.</p>
    </div>
  }
</div>

<!-- Loading logo -->
@if(loading){
  <app-loading-element class="loading-container"></app-loading-element>
}
<!-- Modal pop-up -->
@if(this.manageService.showManageModal){
  <app-manage-modal class="manage-modal" [ngClass]="{ 'modal-active' : this.manageService.showManageModal }"></app-manage-modal>
}
